<script>
import IconImage from "@js/components/Icons/IconImage.vue";

export default {
    name: "CatalogProductSkeleton",
    components: {IconImage}
}
</script>

<template>
    <div class="relative">
        <div
            class="bg-white shadow border border-gray-200 hover:border-indigo-600 rounded-xl transition cursor-pointer">
            <div class="relative overflow-hidden rounded-xl flex flex-col z-1  bg-white">
                <div role="status"
                     class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
                    <div
                        class="flex items-center justify-center w-full h-[175px] bg-gray-300 rounded-sm">
                        <IconImage/>
                    </div>
                </div>
            </div>
            <div class="p-5">
                <div role="status" class="max-w-sm animate-pulse">
                    <div class="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
                    <div class="h-2 bg-gray-200 rounded-full max-w-[360px] mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full max-w-[330px] mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full max-w-[300px] mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full max-w-[360px]"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
